/** Whether the tab was in front or hidden when a report was made (smart-knock: a hidden tab is the one that went cold unwatched). */
export type TabVisibility = 'visible' | 'hidden' | 'unknown';

export function tabVisibility(): TabVisibility {
  if (typeof document === 'undefined') return 'unknown';
  return document.visibilityState === 'hidden' ? 'hidden' : 'visible';
}
